<template>
    <div :id="'modal-navigateaway-'+_uid"  class="modal" tabindex="-1" role="dialog" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body mx-auto">
                    <div class="d-flex flex-column justify-content-center">
                        <div class="d-flex flex-column justify-content-center mt-2">
                            <div class="mx-auto sucesspopup text-center" style="max-width:526px;">
                                <span>Are you sure ?</span>
                            </div>
                        </div>
                        <p class="d-flex flex-column justify-content-center warm mt-2">
                            <div class="mx-auto text-center" style="max-width:460px;">
                                <span>
                                    You will lose your unsaved changes if you leave this page now.
                                </span>
                            </div>
                        </p>
                        <div class="d-flex flex-column justify-content-center mt-4 mb-2">
                            <button type="button" @click="$emit('awayaction',true)" class="btn btn-primary mx-auto" style="width:60%" aria-label="Discard Changes">Discard Changes</button>
                            <button type="button" @click="$emit('awayaction',false)" class="btn btn-link buttonlabel noborder cancel mx-auto mt-2">Cancel</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'navigateaway',
        props: {
            show: {type:Boolean}
        },
        watch: {
            show: {
                handler(val) {
                    if (val == true) {
                        $('#modal-navigateaway-'+this._uid).modal('show');
                    } else {
                        $('#modal-navigateaway-' + this._uid).modal('hide');
                    }
                },
            }
        },
       
    };
</script>